import React from 'react';
import { Tag } from 'antd';
import { useAmplifierI18n } from '../../i18n/amplifier/useAmplifierI18n';

interface ConnectionStatusTagProps {
    /** remote_control 映射后的连接布尔值（hamlib_connection / serial_connection / mqtt_connection） */
    connected: boolean | undefined;
}

/** 系统同步 / 顶栏：根据 remote_control 连接字段展示已连接/未连接 */
export const ConnectionStatusTag: React.FC<ConnectionStatusTagProps> = ({ connected }) => {
    const { t } = useAmplifierI18n();
    const online = connected === true;
    return (
        <Tag className={online ? 'amp-sync-tag amp-sync-tag--online' : 'amp-sync-tag amp-sync-tag--offline'}>
            {online ? t('已连接') : t('未连接')}
        </Tag>
    );
};

export default ConnectionStatusTag;
